import Vue from 'vue'
import './plugins/axios.js'
import './plugins/time.js'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/element.js'
import myfun from '../public/myfun.js'
Vue.prototype.myfun = myfun
import myDB from "../public/myDB.js"
Vue.prototype.myDB = myDB
import '../public/mycss.css'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
